// Ember is already polyfilling Promise as needed, so just use that.
import { Promise as EmberPromise } from 'rsvp';
export default EmberPromise;
